<template>
<div class="login-page">
  <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Login</div>
      </q-card-section>
    <q-separator />

    <q-card-section class="card-content">
      <div class="welcome-login">Welcome to {{ ranName }}</div>
      <div class="field">
        <q-input
          square
          outlined
          label="Username"
          color="white"
          label-color="white"
          outline-color="white"
          :input-style="{ color: 'white' }"
          @update:model-value="(e) => updateCredentials({ field: 'username', value: e})"
          :model-value="username"
          @blur="v$.username.$touch()"
          :error="v$.username.$error"
          :error-message="validation.username.message"
        />
        <q-input
          square
          outlined
          type="password"
          label="Password"
          color="white"
          label-color="white"
          outline-color="white"
          :input-style="{ color: 'white' }"
          @update:model-value="(e) => updateCredentials({ field: 'password', value: e})"
          :model-value="password"
          @blur="v$.password.$touch()"
          :error="v$.password.$error"
          :error-message="validation.password.message"
        />
        <div class="forgot-password" @click="forgotPasswordModal = true">
          Forgot Password?
        </div>
        <q-btn color="black" label="Login" @click="loginRequest"/>
        <q-btn class="register" unelevated label="Signup" text-color="black" @click="registrationModal = true" />
      </div>
    </q-card-section>
  </q-card>
  <registration-modal :open="registrationModal" @close="registrationModal = false"/>
  <forgot-password-modal :open="forgotPasswordModal" @close="forgotPasswordModal = false" />
</div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { useVuelidate } from '@vuelidate/core'
import RegistrationModal from '../registration/RegistrationModal.vue';
import ForgotPasswordModal from '../forgot-password/ForgotPasswordModal.vue'

export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'LoginPage',
  components: {
    RegistrationModal,
    ForgotPasswordModal
  },
  data () {
    return {
      registrationModal: false,
      forgotPasswordModal: false,
      referralCode: '',
      validation: {
        username: {
          error: false,
          message: ''
        },
        password: {
          error: false,
          message: ''
        }
      }
    }
  },
  validations () {
    return {
      username: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(20)
      },
      password: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(20),
      }
    }
  },
  computed: {
    ...mapState({
      username: (state) => state.login.username,
      password: (state) => state.login.password
    }),
    ranName () {
      return process.env.VUE_APP_RAN_NAME
    }
  },
  mounted () {
    if (this.$route.query.referral || Number(this.$route.query.register) === 1) {
      this.registrationModal = true
    }

    this.setupCaptcha()
  },
  methods: {
    ...mapActions({
      updateCredentials: 'login/updateCredentials',
      login: 'login/login',
      updateUserIsLoggedIn: 'user/updateUserIsLoggedIn'
    }),
    async loginRequest () {
      this.v$.username.$touch()
      this.v$.password.$touch()

      if(this.v$.username.$invalid || this.v$.password.$invalid) {
        this.getErrorMesage()
        return
      }
      
      this.$q.loading.show()
      this.login()
        .then(async (response) => {
          localStorage.setItem('authToken', response.data.authToken)
          this.updateUserIsLoggedIn(true)

          this.updateCredentials({ field: 'username', value: ''})
          this.updateCredentials({ field: 'password', value: ''})

          this.$q.notify({
            position: 'top-right',
            message: 'Login Success',
            type: 'positive'
          })

          this.$router.push({ name:'user' })

        })
        .catch((e) => {
          this.$q.loading.hide()
          this.$q.notify({
            position: 'top-right',
            message: e.message,
            type: 'negative'
          })
          
          this.setupCaptcha()
        })
    },
    async setupCaptcha () {
      await this.$recaptchaLoaded()

      const token = await this.$recaptcha('login')

      this.updateCredentials({ field: 'token', value: token })
    },
    getErrorMesage () {
      this.v$.$errors.forEach(element => {
        if (element.$property === 'username') {
          if (element.$validator === 'minLength') {
            this.validation.username.message = 'Username should be atleast 4 characters'
          } else if (element.$validator === 'maxLength') {
            this.validation.username.message = 'Username should not be more than 20 characters'
          } else if (element.$validator === 'required') {
            this.validation.username.message = 'Username is required'
          }
        }
        if (element.$property === 'password') {
          if (element.$validator === 'minLength') {
            this.validation.password.message = 'Password should be atleast 4 characters'
          } else if (element.$validator === 'maxLength') {
            this.validation.password.message = 'Password should not be more than 20 characters'
          } else if (element.$validator === 'required') {
            this.validation.password.message = 'Password is required'
          }
        }
      });
    },
    openRegistration () {
      this.registrationModal = true
    }
  }
}
</script>

<style lang="scss">
.login-page {
  .my-card {
    .card-title {
      font-size: 16px;
      font-weight: 700;
    }
    .card-section {
      background-color: $backgroundHeader;
      color: white;
    }
    .card-content {
      background-color: $background;

      .welcome-login {
        font-size: 16px;
        font-weight: 700;
        color: white;
      }

      .field {
        padding: 16px;
        display: grid;
        grid-template-rows: 1fr;
        gap: 10px;

        .q-field__control:before {
          border-color: white;
        }
        .q-input {
          color: white;
        }
        .register {
          background-color: #FFC108;
        }

        .forgot-password {
          font-size: 12px;
          font-weight: 500;
          color: white;
          cursor: pointer;
        }
      }
    }
    
  }
}
</style>